export default __webpack_public_path__ + "static/media/ic_edit.982e9295.svg";